import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Navigate, Route, Routes } from "react-router";
import { UserApplicationList } from "./UserApplicationList";
import { UserCreate } from "./UserCreate";
import { UserEditForm } from "./UserEditForm";
import { UserEventList } from "./UserEventList";
import { UserList } from "./UserList";
import { UserNavigation } from "./UserNavigation";
import { UserRolesList } from "./UserRolesList";
import { UserTenantsList } from "./UserTenantsList";

export const UsersPage: FC = () => {
	return (
		<Routes>
			<Route index element={<UserList />} />
			<Route path="new" element={<UserCreate />} />
			<Route path=":userId" element={<UserNavigation />}>
				<Route index element={<Navigate to="edit" />} />
				<Route path="edit" element={<UserEditForm />} />
				<Route path="applications" element={<UserApplicationList />} />
				<Route path="events" element={<UserEventList />} />
				<Route path="roles" element={<UserRolesList />} />
				<Route path="tenants" element={<UserTenantsList />} />
				<Route path="*" element={<NotFound />} />
			</Route>
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
